import React from "react";
import Modal from "components/modal";
import { Button } from "semantic-ui-react";

interface Props {
  isOpen: boolean
  apiCall: () => Promise<server.dto.ApiResponseWrapper<number>>
  onSuccess: (itemId: number) => void
  onClose: () => void
}

const ConfirmCopyModal = (props: Props) => {
  const [copying, setCopying] = React.useState<boolean>(false);
  const { apiCall, onSuccess, isOpen, onClose } = props;

  const onCopy = async () => {
    setCopying(true);
    const response = await apiCall();
    if (!response.hasErrors) {
      onSuccess(response.data);
    } else {
      window.displayGenericModal(RESX.ExceptionMessage.ThereIsAProblem, response.errors[0].message, "tiny", "error");
    }
    setCopying(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      width="mini"
      handleClose={onClose}
      title={RESX.Buttons.btnCopy}
      className="force_z"
    >
      <div className="flex-column justify-space-between">
        <div className="margin-bottom">
          {RESX.GeneralWarnings.AreYouSure}
        </div>
        <div className="flex">
          <div className="grow1"></div>
          <div>
            <Button
              color="red"
              onClick={onCopy}
              content={RESX.Buttons.btnCopy}
              name="Copy"
              loading={copying}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmCopyModal;